export default __webpack_public_path__ + "static/media/Path 732.1fd35217.svg";